import { memo } from "react";
import { useTranslation } from 'react-i18next';

const AlertIcon = ({ alert, onClose, onSubmit }) => {
  const { t } = useTranslation();
  return (
    <se-dialog
      id="AlertDialog"
      open={alert.alertPopUpStatus}
      can-backdrop="false"
    >
      <se-dialog-header>{alert.title}</se-dialog-header>
      <se-dialog-content
        icon="information_circle"
        color="primary"
        className="se-header-font-size-16px se-life-green"
      >
        {alert.message}
      </se-dialog-content>
      <se-dialog-footer>
        {onSubmit && <se-button aria-label="alert-confirm" onClick={onSubmit}>{t('profile.ok')}</se-button>}
        {onClose && <se-button aria-label="alert-cancel" onClick={onClose}>{t('common.cancel')}</se-button>}
      </se-dialog-footer>
    </se-dialog>
  );
};

export default memo(AlertIcon);
